import { useNavigate } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { addDoc, collection } from "firebase/firestore";
import { db, auth } from "../firebase/config";

export const CreatePost = () => {
  const navigate = useNavigate();
  useTitle("Create Post")
  const postRef = collection(db, "posts");
  
  async function handleSubmitPost(event){
    event.preventDefault();

    
    const document = {
      title: event.target.title.value,
      description: event.target.description.value,
      author: {
        name: auth.currentUser.displayName,
        id: auth.currentUser.uid
      }
    };
    await addDoc(postRef, document);
    navigate("/");
  }

  return (
    <section className="create">
      <div className="heading">
        <h1>Add New Post</h1>
        <form className="createPost" onSubmit={handleSubmitPost}>
          <input type="text" className="title" name="title" placeholder="Title"/>
          <textarea name="description" className="description" placeholder="description" maxLength="600" required></textarea>
          <button type="submit" className="submit">Create</button>
        </form>
      </div> 
    </section>
  )
}
